import Tooltip from '@assets/components/toolTip';

export default class extends Tooltip {
    init() {
        super.init();
        $('.primary-tooltip').tooltip({
            html: true,
            template: `
                <div class="navbar-tooltip tooltip" role="tooltip">
                    <div class="arrow"></div>
                    <div class="tooltip-inner"></div>
                </div>
            `,
        });

        // hide tooltip if focus is triggered by js
        $('.primary-tooltip a').on('focus', (e) => {
            if (e.isTrigger) {
                $(e.target).parents('.primary-tooltip').tooltip('hide');
            }
        });
    }
}
